var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var self = locals || {};const cookies = self.htmlWebpackPlugin.options.data.content.cookies
pug_html = pug_html + "\u003Cdiv class=\"banner-cookies\" id=\"cookiesbanner\" style=\"display: none;\"\u003E\u003Cdiv class=\"wrapper\"\u003E\u003Cdiv class=\"banner-cookies_l\"\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = cookies.disclaimer_1) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"banner-cookies_r\"\u003E\u003Ca class=\"btn-cookies btn btn-style-1\" id=\"cookies-ok\"\u003E" + (pug.escape(null == (pug_interp = cookies.agree) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/cookies_banner.pug
// module id = 787
// module chunks = 0